var _circle, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFire(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.5,
    cy: 20.5,
    r: 20.5,
    fill: "url(#paint0_radial_160_4)",
    fillOpacity: 0.34
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.66 19.2C26.43 18.9 26.15 18.64 25.89 18.38C25.22 17.78 24.46 17.35 23.82 16.72C22.33 15.26 22 12.85 22.95 11C22 11.23 21.17 11.75 20.46 12.32C17.87 14.4 16.85 18.07 18.07 21.22C18.11 21.32 18.15 21.42 18.15 21.55C18.15 21.77 18 21.97 17.8 22.05C17.57 22.15 17.33 22.09 17.14 21.93C17.0829 21.8828 17.0354 21.8251 17 21.76C15.87 20.33 15.69 18.28 16.45 16.64C14.78 18 13.87 20.3 14 22.47C14.06 22.97 14.12 23.47 14.29 23.97C14.43 24.57 14.7 25.17 15 25.7C16.08 27.43 17.95 28.67 19.96 28.92C22.1 29.19 24.39 28.8 26.03 27.32C27.86 25.66 28.5 23 27.56 20.72L27.43 20.46C27.22 20 26.66 19.2 26.66 19.2ZM23.5 25.5C23.22 25.74 22.76 26 22.4 26.1C21.28 26.5 20.16 25.94 19.5 25.28C20.69 25 21.4 24.12 21.61 23.23C21.78 22.43 21.46 21.77 21.33 21C21.21 20.26 21.23 19.63 21.5 18.94C21.69 19.32 21.89 19.7 22.13 20C22.9 21 24.11 21.44 24.37 22.8C24.41 22.94 24.43 23.08 24.43 23.23C24.46 24.05 24.1 24.95 23.5 25.5Z",
    fill: "#FF0000"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_160_4",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.5 20.5) rotate(90) scale(20.5)"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0000"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFire);
export default __webpack_public_path__ + "static/media/Fire.484985b9ea80e6d0622e7a185cd0475c.svg";
export { ForwardRef as ReactComponent };